{
  "contacts": {
    "all_contacts": "Tous les contacts",
    "all_employees": "Tous les employés",
    "company_type": "Type d'entreprise",
    "consent_status": "Statut de consentement",
    "consent": {
      "management": "Gestion du consentement",
      "edit_consent": "Modifier le consentement",
      "how_was_given": "Comment le consentement a-t-il été donné ?",
      "when_was_given": "Quand le consentement a-t-il été donné ?",
      "how_was_given_display": "Comment le consentement a été donné",
      "when_was_given_display": "Quand le consentement a été donné",
      "status": {
        "consent_given": "Consentement donné",
        "consent_not_given": "Consentement non donné",
        "legitimate_interest": "Intérêt légitime",
        "user_unsubscribed": "Utilisateur désabonné"
      }
    },
    "results": "Résultats",
    "empty_state": "Il n'y a aucun contact à afficher ici",
    "personal_contact_indicator": "-",
    "tabs": {
      "current": "Contacts actuels",
      "previous": "Contacts précédents",
      "who_knows": "Qui connaît",
      "connections": "Connexions"
    },
    "table": {
      "contact": "Contact",
      "interaction": "Interaction",
      "last_interaction": "Dernière interaction",
      "current_company": "Entreprise actuelle",
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Lieu",
        "tags": "Tags",
        "last_interaction_total": "Dernière Interaction (Total)"
      }
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "log_new_activity": "Enregistrer une nouvelle activité",
      "export_selected": "Exporter la sélection",
      "clear_selection": "Effacer la sélection",
      "add_tags": "Ajouter des Tags"
    },
    "order_by": {
      "label": "Trier par",
      "company_name_asc": "nom d'entreprise asc",
      "company_name_desc": "nom d'entreprise desc",
      "created_at_asc": "créé le asc",
      "created_at_desc": "créé le desc",
      "first_name_asc": "prénom asc",
      "first_name_desc": "prénom desc",
      "last_interaction_asc": "dernière interaction asc",
      "last_interaction_desc": "dernière interaction desc",
      "last_name_asc": "nom de famille asc",
      "last_name_desc": "nom de famille desc",
      "number_of_interactions_asc": "nombre d'interaction asc",
      "number_of_interactions_desc": "nombre d'interaction desc",
      "contact_created_at_desc": "contact créé le desc",
      "last_interaction_at_asc": "dernière interaction le asc",
      "last_interaction_at_desc": "dernière interaction le desc",
      "archived_at_asc": "archivé le asc",
      "archived_at_desc": "archivé le desc"
    },
    "selection": {
      "all_selected": "Tous les {{count}} contacts sélectionnés",
      "page_selected": "Tous les {{count}} contacts de cette page sont sélectionnés.",
      "select_all": "Sélectionner tous les {{count}} contacts",
      "modal": {
        "header": "Contacts sélectionnés ({{count}})",
        "link_text": "{{count}} sélectionnés"
      },
      "limit": {
        "exceeded": "Vous avez atteint la limite de sélection de {{limit}} contacts.",
        "tooltip": "La limite de sélection de contacts a été atteinte",
        "tooltip_will_be_reached": "La limite de sélection de contacts a été atteinte ou sera atteinte"
      },
      "accessibility": {
        "select_contact": "sélectionner {{email}}",
        "select_all": "tout sélectionner"
      }
    },
    "errors": {
      "add_to_list": "Erreur lors de l'ajout de contacts à la liste"
    },
    "accessibility": {
      "private_contact": "Contact privé",
      "view_hierarchy": "voir la hiérarchie des contacts"
    },
    "slide": {
      "tabs": {
        "details": "Détails du contact",
        "connections": "Qui connaît",
        "activities": "Flux d'activité",
        "notes": "Notes",
        "tasks": "Tâches",
        "marketing_settings": "Préférences Marketing",
        "engagement": "Engagement",
        "opportunities": "Opportunités",
        "list_fields": "Champs de liste"
      },
      "loading": {
        "list_fields": "Chargement des champs de liste..."
      },
      "details": {
        "labels": {
          "email": "Courriel",
          "job_title": "Titre du poste",
          "contact_location": "Emplacement du contact",
          "contact_office_address": "Adresse du bureau du contact",
          "contact_numbers": "Numéros de contact",
          "twitter_url": "URL Twitter",
          "linkedin_url": "URL LinkedIn",
          "education": "Éducation",
          "tags": "Tags",
          "company": "Entreprise",
          "primary_location": "Emplacement principal",
          "company_primary_location": "Emplacement principal de l'entreprise",
          "industries": "Industries",
          "internal_industries": "Industries internes"
        },
        "tooltips": {
          "contact_office_address": "L'emplacement du bureau principal pour ce contact spécifique"
        },
        "placeholders": {
          "no_data": "--",
          "not_available": "N/D"
        }
      },
      "notes": {
        "empty_state": "Il n'y a pas encore de note sur ce contact"
      },
      "profile": {
        "sections": {
          "basic_information": "Informations de base",
          "company_information": "Informations sur l'entreprise",
          "custom_fields": "Champs personnalisés",
          "tags": "Tags",
          "list_memberships": "Listes",
          "other_accounts": "Autres comptes"
        },
        "labels": {
          "contact_office_location": "Emplacement du bureau du contact",
          "emails": "Courriels",
          "phone_numbers": "Numéros de téléphone",
          "primary": "Principal",
          "last_interaction": "Dernière interaction",
          "added_by": "Ajouté par"
        },
        "actions": {
          "edit_details": "Modifier les détails",
          "update_contact": "Mettre à jour le contact",
          "edit_contact": "Modifier le contact",
          "move_in_hierarchy": "Déplacer dans la hiérarchie",
          "unarchive": "Désarchiver",
          "audit_trail": "Piste d'audit",
          "create": "Créer",
          "task": "Tâche",
          "note": "Note",
          "opportunity": "Opportunité",
          "add_to_list": "Ajouter à la liste",
          "log_new_activity": "Enregistrer une nouvelle activité",
          "actions": "Actions",
          "add_to_my_contact": "Ajouter à mes contacts",
          "remove_from_my_contact": "Retirer de mes contacts",
          "report_incorrect_info": "Signaler des informations incorrectes",
          "mark_company_changed": "Marquer comme \"Entreprise changée\"",
          "archive_contact": "Archiver le contact",
          "create_opportunity": "Créer une opportunité",
          "add_contact_to_list": "Ajouter le contact à une liste",
          "sync_contact_with_outlook": "Synchroniser le contact avec Outlook",
          "ignore": "Ignorer",
          "update_current_company": "Mettre à jour l'entreprise actuelle",
          "link_another_contact": "Lier un autre contact",
          "link": "Lier",
          "more_actions": "Plus d'actions"
        },
        "tooltips": {
          "add_to_my_contact": "Ajouter à mes contacts",
          "create_task": "Créer une tâche",
          "create_note": "Créer une note",
          "copy_email_to_clipboard": "Copier le courriel dans le presse-papiers",
          "copy_phone_number_to_clipboard": "Copier le numéro de téléphone dans le presse-papiers",
          "remove_bounced_status": "Supprimer le statut de rebond",
          "more_actions": "Plus d'actions"
        },
        "accessibility": {
          "primary_email_indicator": "Indicateur de courriel principal pour {{email}}",
          "update_basic_information": "mettre à jour les informations de base",
          "update_contact_office_location": "mettre à jour l'emplacement du bureau du contact",
          "add_new_email": "ajouter un nouveau courriel",
          "add_new_phone_number": "ajouter un nouveau numéro de téléphone",
          "update_custom_fields": "mettre à jour les champs personnalisés",
          "add_to_membership_list": "ajouter à la liste d'adhésion",
          "contact_actions": "actions du contact",
          "unarchive_contact": "Désarchiver {{contactName}}",
          "archive_contact": "Archiver le contact",
          "remove_bounced_status": "Supprimer le statut rebondi",
          "more_actions": "Plus d'actions"
        },
        "modals": {
          "update_current_company": "Mettre à jour l'entreprise actuelle",
          "company_change": {
            "question": "Comment souhaitez-vous mettre à jour l'entreprise actuelle ?",
            "helper_text": "Sélectionnez option pour mettre à jour l'entreprise actuelle",
            "options": {
              "add_new_work_email": "Ajouter un nouveau courriel professionnel",
              "add_new_company": "Ajouter une nouvelle entreprise",
              "add_personal_email": "Ajouter un courriel personnel",
              "no_details": "Je n'ai aucun détail"
            },
            "helper_text_no_details": "Nous montrerons que le contact a changé d'emploi aux autres utilisateurs. Vous pourrez ajouter la nouvelle entreprise à ce contact plus tard. Nous n'archiverons pas le contact",
            "form": {
              "labels": {
                "new_work_email": "Nouveau courriel professionnel",
                "company_name": "Nom de l'entreprise",
                "linkedin_url": "URL LinkedIn",
                "personal_email": "Courriel personnel"
              },
              "tooltips": {
                "new_work_email": "Veuillez ajouter un courriel professionnel de la nouvelle entreprise. Le courriel doit provenir d'un domaine différent. Pour ajouter un autre courriel du même domaine - utilisez l'option Mettre à jour le courriel",
                "company_name": "Veuillez ajouter la nouvelle entreprise pour le contact. Recherchez des entreprises existantes ou créez une nouvelle entreprise si l'enregistrement n'existe pas",
                "linkedin_url": "Veuillez ajouter l'URL du profil LinkedIn pour le contact. Il est acceptable que le profil LinkedIn ne soit pas mis à jour avec le nouveau poste.",
                "personal_email": "Veuillez ajouter le courriel personnel pour le contact."
              },
              "placeholders": {
                "new_work_email": "Tapez le nouveau courriel professionnel",
                "company_name": "Sélectionnez ou tapez l'entreprise",
                "linkedin_url": "Tapez l'URL LinkedIn",
                "personal_email": "Tapez le courriel personnel"
              },
              "checkboxes": {
                "remove_from_lists": "Retirer de toutes les listes de marketing.",
                "archive_previous": "Archiver le contact précédent"
              }
            }
          },
          "edit_contact": "Modifier le contact",
          "link_contact": "Lier le contact",
          "unsaved_changes": "Modifications non sauvegardées"
        },
        "status": {
          "last_interaction": "Dernière interaction",
          "company_changed": "Ce contact a changé d'entreprise. Veuillez mettre à jour.",
          "email_bounced": "Le courriel {{emails}} de ce contact a récemment rebondi. Veuillez mettre à jour.",
          "company_changed_and_email_bounced": "Ce contact a changé d'entreprise. Le courriel {{emails}} de ce contact a récemment rebondi. Veuillez mettre à jour.",
          "new_company_unknown": "Nouvelle entreprise inconnue. Cliquez sur plus d'options pour mettre à jour l'entreprise",
          "new_company_unknown_with_description": "Nouvelle entreprise inconnue. Cliquez sur plus d'options pour mettre à jour l'entreprise",
          "archived": "Archivé",
          "bounced": "Rebondi",
          "unengaged": "Non engagé",
          "changed_company": "Entreprise changée",
          "company_changed_success": "Ce contact est maintenant marqué comme \"Entreprise changée\"",
          "company_changed_description": "Nous montrerons que le contact a changé d'entreprise aux autres utilisateurs. Si vous avez de nouveaux détails de contact pour cette personne, envisagez de les ajouter maintenant."
        },
        "status_tooltips": {
          "unengaged": "Contacts qui n'ont eu aucune interaction ou point de contact avec votre organisation depuis plus d'un an.",
          "new_company_unknown": "L'entreprise indiquée est l'ancienne entreprise du contact."
        },
        "confirmations": {
          "ignore_warning_title": "Ignorer l'avertissement ?",
          "ignore_warning_content": "Pour continuer, veuillez confirmer que le contact n'a pas changé d'entreprise.",
          "archive_title": "Êtes-vous sûr de vouloir archiver ce contact ?",
          "archive_content": "Ce contact ne sera plus visible dans la recherche. Si c'est le seul contact, cette personne sera également archivée et ne sera plus visible dans la recherche.",
          "archive_until_next_interaction": "Archiver jusqu'à la prochaine interaction",
          "learn_more_about_interactions": "En savoir plus sur les interactions",
          "here": "ici",
          "archive_success_title": "Vous avez archivé le contact avec succès",
          "archive_success_description": "Ce contact n'apparaîtra plus dans la recherche. Si c'est le seul contact lié à cette personne, l'archivage peut affecter la façon dont la personne est affichée dans Nexl. Si vous avez un nouveau contact pour cette personne, envisagez de l'ajouter maintenant.",
          "add_new_contact_link": "Je veux ajouter un nouveau contact",
          "unsaved_changes_message": "Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir continuer sans sauvegarder ?",
          "link_contact_caption": "Lier ce contact à l'entreprise du contact actuel"
        },
        "tabs": {
          "basic_information": "Informations de base",
          "company": "Entreprise"
        },
        "form": {
          "labels": {
            "job_title": "Titre du poste",
            "email": "Courriel",
            "phone_number": "Numéro de téléphone",
            "custom_fields": "Champs personnalisés",
            "set_as_primary": "Définir comme principal",
            "first_name": "Prénom",
            "last_name": "Nom de famille",
            "contact_location": "Emplacement du contact",
            "address": "Adresse",
            "education": "Éducation",
            "social_media": "Médias sociaux",
            "linkedin": "LinkedIn",
            "twitter": "Twitter",
            "linkedin_url": "URL LinkedIn",
            "twitter_url": "URL Twitter",
            "contact": "Contact"
          },
          "tooltips": {
            "email_domain": "Veuillez utiliser un courriel du même domaine courriel qui n'est pas encore un contact."
          },
          "messages": {
            "changes_saved": "Modifications enregistrées !",
            "loading_contact_data": "Chargement des données de contact",
            "form_error": "Une erreur s'est produite lors de la soumission du formulaire.",
            "loading_linked_contacts": "Chargement des contacts liés"
          },
          "placeholders": {
            "type_email_or_name": "Tapez le courriel ou le nom",
            "search_address": "Rechercher une adresse",
            "education_multiple": "Éducation (Multiple)"
          },
          "validation": {
            "same_domain_error": "Les comptes doivent avoir des domaines différents. Utilisez l'onglet 'Informations de base' pour un courriel avec le même domaine"
          }
        }
      }
    },
    "archive_person": {
      "confirm_title": "Êtes-vous sûr de vouloir archiver la personne ?",
      "contacts_impacted": "Ces contacts seront impactés",
      "understanding_checkbox": "Je comprends qu'archiver la personne archivera tous les contacts associés à cette personne.",
      "archive_until_interaction": "Archiver jusqu'à la prochaine interaction",
      "archive_all_selected": "Archiver tout sélectionné"
    },
    "mark_company_changed": {
      "modal_title": "Marquer comme \"Entreprise changée\"",
      "modal_caption": "Nous montrerons que le contact a changé d'entreprise aux autres utilisateurs. Alternativement, vous pouvez archiver ce contact et ajouter un nouveau contact à cette personne.",
      "add_new_contact_button": "Je veux ajouter un nouveau contact",
      "continue": "Continuer",
      "confirmation_title": "Êtes-vous sûr de vouloir marquer ce contact comme \"Entreprise changée\" ?",
      "remove_from_marketing_lists": "Retirer de toutes les listes marketing",
      "options": {
        "mark_changed": "Marquer ce contact comme \"Entreprise changée\"",
        "mark_changed_helper": "Nous n'archiverons pas le contact actuel.",
        "archive_contact": "Archiver ce contact",
        "archive_contact_helper": "Nous archiverons ce contact. Vous pouvez également ajouter un nouveau contact."
      }
    },
    "add_new_contact": {
      "continue": "Continuer",
      "add_new_contact": "Ajouter un nouveau contact",
      "success": "Vous avez créé avec succès un nouveau contact",
      "first_step_header": "Ajouter un nouveau contact au personne",
      "first_step_header_description": "Ajoutez un nouveau courriel professionnel ou personnel à la personne et nous créons un nouveau contact basé sur celui-ci.",
      "email_already_exist_in_this_person": "Cette adresse courriel existe déjà dans les dossiers de cette personne. Vérifiez vos contacts archivés si vous ne la voyez pas.",
      "email_already_exist_in_another_person": "Cette adresse courriel existe déjà dans les dossiers d'une autre personne. Vérifiez vos contacts archivés si vous ne la voyez pas.",
      "i_dont_have_email_for_this_contact": "Je n'ai pas de courriel pour ce contact",
      "this_person_already_has_a_contact_with_this_company": "Cette personne a déjà un contact avec cette entreprise.",
      "company_name": "Nom de l'entreprise",
      "switch_back_to_email": "Revenir au courriel",
      "email": "Courriel",
      "job_title": "Titre du poste",
      "add_company_contact": "Ajouter une entreprise",
      "we_detected_this_email_is_a_company_email": "Nous avons détecté que cet courriel est celui d'une entreprise. Veuillez vérifier les détails",
      "there_was_an_error_validating_the_email": "Il y a eu une erreur lors de la validation du courriel",
      "please_use_a_valid_email_address": "Veuillez utiliser une adresse courriel valide",
      "are_you_sure_you_want_to_consolidate_these_persons_into_single_person_profile": "Êtes-vous sûr de vouloir consolidater ces personnes dans un seul dossier de personne?",
      "personal_details": "Détails personnels",
      "contacts": "Contacts",
      "review_potential_duplicates_of_the_person": "Vérifier les doublons potentiels de la personne",
      "we_detected_potential_person_duplicate_for_the_email_you_want_to_add": "Nous avons détecté un doublon potentiel pour l'adresse courriel que vous souhaitez ajouter. Vous pouvez le signaler pour vérification par l'administrateur.",
      "potential_duplicates_have_been_flagged_for_review": "Les doublons potentiels ont été signalés pour vérification.",
      "thanks_for_helping_keep_our_data_clean": "Merci pour l'aide à garder nos données propres. Les utilisateurs administrateurs vérifieront et prendront des actions pour gérer ces enregistrements.",
      "start_consolidating": "Commencer la consolidation",
      "flag_as_duplicates": "Signalé comme doublon",
      "move_email": "Déplacer l'courriel?",
      "we_might_have_misplaced_the_email": "Ces personnes ne sont pas des doublons, donc nous avons peut-être perdu l'courriel. Voulez-vous le déplacer vers le dossier actuel?",
      "visit_profile": "Visiter le profil",
      "these_are_not_duplicates": "Ces personnes ne sont pas des doublons",
      "form": {
        "title": "Ajouter un contact",
        "validation": {
          "email_invalid": "Ceci n'est pas un courriel valide",
          "url_invalid": "Ceci n'est pas une URL valide",
          "email_or_linkedin_required": "Vous devez fournir soit un courriel soit une URL LinkedIn"
        },
        "labels": {
          "linkedin_url": "URL LinkedIn"
        }
      },
      "merge": {
        "title": "Mettre à jour le courriel",
        "button_text": "Mettre à jour le courriel du contact",
        "validation": {
          "contact_required": "Le contact est requis"
        },
        "labels": {
          "contact": "Contact",
          "placeholder": "Quel est le courriel actif de ce contact ?"
        },
        "actions": {
          "set_email": "Définir le courriel"
        }
      }
    },
    "archived": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "last_interaction": "Dernière interaction",
          "archived_at": "Archivé le",
          "action": "Action"
        }
      },
      "unarchive_on_next_interaction": "Ce contact sera automatiquement désarchivé lors de la prochaine interaction",
      "changed_company": "Entreprise changée",
      "actions": {
        "archive_contact": {
          "confirm_title": "Archiver le contact ?",
          "confirm_content": "Veuillez confirmer l'archivage du contact.",
          "bulk_confirm_title_single": "Archiver le contact ?",
          "bulk_confirm_title_multiple": "Archiver les contacts ?",
          "bulk_confirm_content_single": "Veuillez confirmer l'archivage du contact.",
          "bulk_confirm_content_multiple": "Veuillez confirmer l'archivage des contacts.",
          "automatically_unarchive": "Désarchiver automatiquement lors de la prochaine interaction",
          "learn_more_interactions": "En savoir plus sur les interactions",
          "here": "ici"
        },
        "unarchive_contact": {
          "confirm_title": "Désarchiver le contact ?",
          "confirm_content": "Veuillez confirmer le désarchivage du contact.",
          "bulk_confirm_title": "Désarchiver les contacts ?",
          "bulk_confirm_content": "Veuillez confirmer le désarchivage des contacts.",
          "label": "désarchivage en masse"
        },
        "purge_contact": {
          "modal_header": "Purger le contact",
          "modal_caption": "Supprimer définitivement les informations de contact, adresses courriel, piste d'audit, listes marketing, qui connaît, notes et tâches.",
          "warning_message": "Une fois que vous procédez, cette action ne peut pas être annulée.",
          "reason_label": "Raison",
          "reason_placeholder": "Saisissez la raison de la purge"
        }
      },
      "order_by": {
        "label": "Trier par"
      }
    },
    "tags": {
      "add_tags": "Ajouter des Tags",
      "tags": "Tags"
    },
    "email": {
      "remove_email": "supprimer le courriel {{email}}",
      "remove_title": "Supprimer {{email}}",
      "remove_confirmation": "Êtes-vous sûr de vouloir supprimer {{email}} ?"
    },
    "location": {
      "contact_location": "Localisation du contact"
    },
    "report_incorrect_info": {
      "report_incorrect_info": "Signaler des informations incorrectes",
      "modal_header": "Signaler des informations de contact incorrectes",
      "incorrect_fields": "Champs incorrects",
      "comments": "Commentaires",
      "report": "Signaler",
      "fields": {
        "name": "Nom",
        "job_title": "Titre du poste",
        "location": "Localisation",
        "phone_numbers": "Numéros de téléphone",
        "twitter_url": "URL Twitter",
        "linkedin_url": "URL LinkedIn",
        "education": "Éducation"
      }
    },
    "preferences": {
      "preference_management": "Gestion des préférences",
      "no_preferences_set": "Il semble que vous n'ayez pas encore défini de préférences pour ce contact.",
      "add_preference": "Ajouter une préférence",
      "no_preferences_schema": "Il semble que vous n'ayez pas encore défini de préférences.",
      "edit_contact_preferences": "Modifier les préférences du contact",
      "edit_preference": "Modifier la préférence"
    },
    "incomplete": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "last_interaction_total": "Dernière interaction (Total)",
          "created_at": "Créé le",
          "missing_info": "Informations manquantes",
          "actions": "Actions",
          "email": "Courriel",
          "contact_location": "Localisation du contact",
          "contact_street_address": "Adresse du contact",
          "contact_city": "Ville du contact",
          "contact_state": "État/Province du contact",
          "contact_postcode": "Code postal du contact",
          "contact_country": "Pays du contact",
          "contact_office_location": "Localisation du bureau de contact",
          "office_street_address": "Adresse du bureau",
          "office_city": "Ville du bureau",
          "office_state": "État/Province du bureau",
          "office_postcode": "Code postal du bureau",
          "office_country": "Pays du bureau",
          "company_type": "Type d'entreprise",
          "contact_consent_status": "Statut de consentement du contact",
          "last_interaction": "Dernière interaction",
          "added_date": "Date d'ajout",
          "last_updated": "Dernière mise à jour",
          "number_of_interactions": "Nombre d'interactions",
          "number_of_meetings": "Nombre de réunions",
          "company_tags": "Tags d'entreprise",
          "contact_tags": "Tags de contact",
          "company_industries": "Secteurs d'entreprise",
          "company_internal_industries": "Secteurs internes d'entreprise",
          "who_knows": "Qui connaît"
        }
      },
      "actions": {
        "ignore_contact": "ignorer le contact",
        "edit_contact": "modifier le contact",
        "bulk_ignore": "ignorer en masse",
        "bulk_archive": "archiver en masse",
        "export_contacts": "Exporter les contacts"
      },
      "forms": {
        "labels": {
          "first_name": "Prénom",
          "last_name": "Nom de famille",
          "job_title": "Titre du poste",
          "street_address": "Adresse",
          "city": "Ville",
          "state": "État/Province",
          "postcode": "Code postal",
          "contact_location": "Localisation du contact",
          "company_location": "Localisation de l'entreprise",
          "office_location": "Localisation du bureau",
          "contact_office_address": "Adresse du bureau de contact"
        },
        "placeholders": {
          "search_address": "Rechercher une adresse"
        }
      },
      "status": {
        "loading_contact_data": "Chargement des données de contact",
        "selected": "Sélectionné"
      },
      "modals": {
        "edit": "Modifier",
        "update_contact_data": "Mettre à jour les données de contact",
        "bulk_edit": "Modification en masse",
        "incomplete_update_contact": "Mise à jour de contact incomplète"
      },
      "grid": {
        "all_incomplete": "Tous incomplets",
        "rows_per_page": "Lignes par page",
        "editable": "Modifiable"
      },
      "order_by": {
        "label": "Trier par",
        "sort_by": "Trier par"
      }
    },
    "export": {
      "export_contacts": "Exporter les contacts"
    },
    "switch_contact": {
      "switch_button": "Changer",
      "switch_tooltip": "Ce contact a plusieurs adresses courriel. Cliquez pour basculer entre elles.",
      "switch_account_modal": "Changer de compte"
    },
    "who_knows": {
      "categories": {
        "our_firm": "Notre cabinet",
        "colleagues": "Collègues",
        "third_party": "Tiers"
      },
      "empty_state": "Il semble que personne ne connaisse ce contact :(",
      "load_more_current": "Voici toutes les personnes qui connaissent ce contact.",
      "also_known_by": "Également connu par",
      "load_more_previous": "Voici toutes les personnes qui connaissaient auparavant ce contact.",
      "through_job": "via {{job}}"
    },
    "duplicate": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "who_knows": "Qui connaît",
          "last_interaction": "Dernière interaction",
          "same_person_question": "Est-ce la même personne ?"
        }
      },
      "actions": {
        "yes": "Oui",
        "no": "Non"
      },
      "merge": {
        "modal_title_same_company": "Veuillez sélectionner les détails de contact corrects. ",
        "modal_title_different_company": "Veuillez sélectionner le contact qui est toujours actif",
        "description_with_email": "Nous combinerons les adresses courriel, les adhésions aux listes, le flux d'activité et les notes des deux contacts.",
        "description_without_email": "Nous combinerons les adhésions aux listes, le flux d'activité et les notes des deux contacts.",
        "archive_warning": "Les détails restants et le compte du contact non sélectionné seront archivés.",
        "both_accounts_active": "Les deux comptes sont toujours actifs"
      },
      "keep_both": {
        "confirm_title": "Confirmer pour garder les deux contacts",
        "confirm_content": "Cette action supprimera définitivement les contacts de cette liste.",
        "label": "contacts actifs"
      },
      "order_by": "Trier par"
    },
    "company_contacts": {
      "empty_state": {
        "title": "Aucun contact pour le moment",
        "description": "Cette entreprise n'a pas encore de contacts. Ajoutez un nouveau contact pour commencer."
      },
      "table": {
        "headers": {
          "contact": "Contact",
          "email": "Courriel",
          "location": "Lieu",
          "tags": "Tags",
          "interactions_count": "Nombre d'interactions",
          "last_interaction": "Dernière interaction"
        }
      },
      "actions": {
        "stay_in_touch": "Rester en contact",
        "add_tags": "Ajouter des Tags",
        "move_contacts_in_hierarchy": "Déplacer les contacts dans la hiérarchie",
        "all_contacts_selected": "Tous les {{count}} contacts sélectionnés"
      },
      "sync": {
        "labels": {
          "first_name": "Prénom",
          "last_name": "Nom de famille",
          "emails": "Courriel(s)",
          "business_phone": "Téléphone professionnel",
          "job_title": "Titre du poste",
          "business_address": "Adresse professionnelle",
          "company_name": "Nom de l'entreprise",
          "office_location": "Emplacement du bureau",
          "company_numbers": "Numéros de l'entreprise"
        },
        "dialog": {
          "title": "Voulez-vous synchroniser ce contact avec Outlook ?",
          "description": "Les données suivantes de ce contact seront synchronisées avec Outlook. Ce contact n'a pas de prénom. Veuillez ajouter un prénom pour synchroniser ce contact.",
          "description_with_emails": "Les données suivantes de ce contact seront synchronisées avec Outlook.\n    Les courriels et numéros de téléphone seront ajoutés aux courriels et numéros existants\n     s'ils existent. Les autres informations remplaceront les informations actuelles."
        },
        "result": {
          "success_title": "Contact Outlook synchronisé",
          "success_description": "Veuillez vérifier votre contact Outlook pour les informations mises à jour",
          "error_title": "Échec de la synchronisation du contact",
          "error_description": "Oups ! Quelque chose s'est mal passé lors de la synchronisation du contact. Veuillez réessayer plus tard."
        }
      },
      "messages": {
        "move_request_received": "Nous avons reçu votre demande de déplacement de contact(s). Cela prend généralement 20 à 30 secondes à traiter."
      }
    }
  },
  "prospects": {
    "title": "Développer les relations clients / Prospect",
    "search": {
      "name": "Nom",
      "job_title": "Titre du poste",
      "location": "Localisation"
    },
    "table": {
      "prospect": "Prospect",
      "location": "Localisation",
      "email": "Courriel",
      "action": "Action"
    },
    "banner": "Nous faisons de notre mieux pour maintenir les résultats aussi à jour que possible, mais vous pourriez trouver des contacts qui ont déjà rejoint une nouvelle entreprise. Veuillez vérifier le profil LinkedIn du contact pour obtenir les informations les plus récentes. Toutes les adresses courriel fournies ne peuvent pas être vérifiées. Par conséquent, nous ne pouvons pas garantir l'exactitude des coordonnées fournies. N'utilisez pas les prospects dans vos campagnes de courriels automatisées.",
    "status": {
      "searching": "Recherche en cours",
      "still_searching": "Recherche toujours en cours",
      "view_contact": "Voir le contact",
      "no_contact_details": "Nous n'avons pas encore trouvé de coordonnées. Veuillez vérifier à nouveau dans 30 minutes."
    }
  },
  "insights": {
    "stats": {
      "activity_past_90_days": "Activité des 90 derniers jours",
      "updated": "Mis à jour {{timeAgo}}",
      "interactions": "Interactions",
      "emails": "Courriels",
      "meetings": "Réunions"
    },
    "engagement": {
      "over_time": "Engagement au fil du temps"
    },
    "contacts": {
      "most_active": "Contacts les plus actifs"
    },
    "opportunities": {
      "opportunity": "Opportunité",
      "referrals": "Références",
      "success_rate": "Taux de réussite",
      "total_open": "Total opportunités ouvertes ({{count}})",
      "total_won": "Total opportunités gagnées ({{count}})",
      "total_open_referred": "Total opportunités ouvertes référées ({{count}})",
      "total_referred_won": "Total opportunités référées gagnées ({{count}})",
      "amount_in": "Montant en {{currency}}"
    },
    "departments": {
      "engagement_by_practice": "Engagement par groupe de pratique",
      "practice_group": "Groupe de pratique",
      "interactions": "Interactions"
    }
  },
  "reporting": {
    "iframe_title": "rapports d'entreprise (PowerBI)"
  },
  "tabs": {
    "overview": "Aperçu",
    "insights": "Perspectives",
    "contacts": "Contacts",
    "prospects": "Prospects",
    "activities": "Activités",
    "documents": "Documents",
    "reporting": "Rapports",
    "opportunities": "Opportunités",
    "notes": "Notes",
    "tasks": "Tâches",
    "research": "Recherche",
    "directory": "RÉPERTOIRE",
    "create_task": "Créer une tâche",
    "loading_notes": "Chargement des notes...",
    "sent_referrals": "Références envoyées",
    "loading": "Chargement...",
    "aria_labels": {
      "active_opportunities": "opportunités actives",
      "open_tasks": "tâches ouvertes"
    },
    "additional": {
      "name_taken": "Le nom est déjà pris"
    }
  },
  "companies": {
    "all_companies": "Toutes les entreprises",
    "incomplete": {
      "table": {
        "headers": {
          "company": "Entreprise",
          "last_interaction_total": "Dernière interaction (Total)",
          "created_at": "Créé le",
          "type": "Type",
          "missing_info": "Informations manquantes",
          "actions": "Actions"
        }
      },
      "actions": {
        "update_company": "Mettre à jour l'entreprise",
        "ignore_company": "ignorer l'entreprise",
        "edit_company": "modifier l'entreprise",
        "export_companies": "Exporter les entreprises"
      },
      "bulk_actions": {
        "ignore": "Ignorer",
        "archive": "Archiver"
      },
      "order_by": "Trier par",
      "update": {
        "modal_title": "Mettre à jour les données de l'entreprise",
        "loading": "Chargement de l'entreprise",
        "form": {
          "type": "Type",
          "industries": "Industries",
          "street_address": "Adresse postale",
          "city": "Ville",
          "state": "État/Province",
          "postcode": "Code postal",
          "set_primary_location": "Définir comme emplacement principal"
        }
      }
    },
    "duplicate": {
      "table": {
        "headers": {
          "company": "Entreprise",
          "type": "Type",
          "contacts": "Contacts",
          "last_interaction": "Dernière interaction",
          "action": "Action"
        }
      },
      "actions": {
        "merge": "Fusionner",
        "keep_both": "Garder les deux",
        "continue": "Continuer"
      },
      "merge": {
        "modal_title": "Fusionner l'entreprise",
        "manual_modal_title": "Fusion manuelle",
        "description": "Nous combinerons les contacts et interactions des deux entreprises. Les notes, tâches et documents de l'entreprise non sélectionnée seront définitivement supprimés.",
        "manual_description": "Nous combinerons les contacts et interactions des deux entreprises. Toutes les notes, tâches et documents autres que ceux de l'entreprise principale seront définitivement supprimés.",
        "warning": "Les entreprises fusionnées ne peuvent pas être annulées. Veuillez vous assurer de sélectionner la bonne entreprise.",
        "select_main_company": "Veuillez sélectionner l'entreprise comme contact principal :",
        "main_company": "Entreprise principale",
        "company_to_merge": "Entreprise à fusionner",
        "type_to_confirm": "Tapez \"{{label}}\" pour confirmer",
        "placeholder_merge": "Tapez pour rechercher l'entreprise principale",
        "placeholder_to_merge": "Tapez pour rechercher l'entreprise à fusionner",
        "merged_result_preview": "Aperçu du résultat fusionné",
        "placeholder_confirm": "Tapez \"Fusionner\" pour confirmer",
        "continue": "Continuer"
      },
      "keep_both": {
        "button": "Garder les deux !",
        "confirm_title": "Voulez-vous ajouter ces entreprises à la même hiérarchie ?",
        "confirm_content": "En les ajoutant comme hiérarchie, vous les connectez en tant que groupe.",
        "yes": "Oui",
        "no_separate": "Non, les garder séparées"
      },
      "order_by": "Trier par"
    },
    "table": {
      "empty_message": "Il n'y a aucune entreprise à afficher ici",
      "headers": {
        "company": "Entreprise",
        "location": "Emplacement",
        "contacts": "Contacts",
        "type": "Type",
        "engagement": "Engagement",
        "last_interaction": "Dernière interaction",
        "last_interaction_total": "Dernière interaction (Total)",
        "contact": "Contact",
        "interactions_count": "# d'interactions",
        "past_role_at": "Ancien rôle chez",
        "year_left": "Année de départ"
      },
      "actions": {
        "export_selected": "Exporter la sélection",
        "download_export": "Télécharger l'export",
        "clear_selection": "Effacer la sélection"
      },
      "row_aria_label": "ligne de entreprise"
    },
    "slide": {
      "tabs": {
        "list_fields": "Champs de liste",
        "contacts": "Contacts",
        "who_knows": "Qui connaît",
        "tasks": "Tâches",
        "opportunities": "Opportunités",
        "documents": "Documents",
        "notes": "Notes"
      },
      "info": {
        "type": "Type",
        "contacts": "Contacts",
        "last_meeting": "Dernière réunion",
        "last_interaction": "Dernière interaction",
        "internal_owner": "Propriétaire interne",
        "status": "Statut",
        "estimated_fee": "Honoraires estimés"
      }
    },
    "form": {
      "create_company": "Créer une entreprise",
      "update_company": "Mettre à jour l'entreprise",
      "company_domain": "Domaine de l'entreprise",
      "company_name": "Nom de l'entreprise",
      "type": "Type",
      "internal_industries": "Industries internes",
      "industries": "Industries",
      "client_id": "ID client",
      "group_id": "ID groupe",
      "description": "Description",
      "phone_numbers": "Numéros de téléphone",
      "company_emails": "Courriels de l'entreprise",
      "linkedin": "LinkedIn",
      "twitter": "Twitter",
      "website": "Site web",
      "number_of_employees": "Nombre d'employés",
      "validation": {
        "company_domain_required": "Le domaine de l'entreprise est requis",
        "valid_domain": "Veuillez saisir un domaine valide"
      }
    },
    "export": {
      "export_companies": "Exporter les entreprises"
    },
    "connections": {
      "description": "Personnes de votre réseau ayant une expérience antérieure dans cette entreprise"
    },
    "opportunities": {
      "loading": "Chargement des opportunités",
      "search_placeholder": "Rechercher",
      "status_all": "Tous",
      "date_label": "Date",
      "opportunity_number": "Opportunité #",
      "open_opportunity_slide": "Ouvrir le volet d'opportunité",
      "total_opportunity_value": "Valeur totale des opportunités :",
      "not_accessible": "Non accessible",
      "not_accessible_tooltip": "La valeur totale n'est pas accessible car certains détails d'opportunité sont privés.",
      "no_access_message": "Vous n'avez pas accès à cette opportunité."
    },
    "autocomplete": {
      "no_options": "commencez à taper pour rechercher des entreprises"
    },
    "avatar": {
      "blocked": "Bloqué"
    },
    "actions": {
      "remove_key_contact": "supprimer le contact clé",
      "confirm_remove_title": "Êtes-vous sûr ?",
      "confirm_remove_content": "Confirmez que vous souhaitez supprimer ce contact clé."
    },
    "status": {
      "loading_notes": "Chargement des notes..."
    },
    "latest_activities": {
      "title": "Dernières activités BD et marketing",
      "last_bd_activity": "Dernière activité BD",
      "last_marketing_activity": "Dernière activité marketing",
      "log_new_activity": "Enregistrer une nouvelle activité",
      "loading_timeline": "Récupération de votre chronologie d'activités clés",
      "empty_state_alt": "Aucune activité de développement des affaires ou marketing trouvée"
    },
    "industry_update": {
      "add_industry": "[Ajouter une industrie]",
      "industries_label": "Industries"
    },
    "blocking": {
      "block_title": "Bloquer l'entreprise ?",
      "block_content": "Cette action supprimera toutes les interactions pour l'entreprise et s'assurera qu'aucune nouvelle ne soit enregistrée",
      "block_button": "Bloquer",
      "block_aria_label": "bloquer l'entreprise",
      "unblock_title": "Débloquer l'entreprise ?",
      "unblock_content": "Veuillez confirmer pour débloquer l'entreprise",
      "unblock_button": "Débloquer"
    },
    "meetings": {
      "last_meeting_title": "Dernière réunion",
      "no_meeting_title": "Vous n'avez pas encore eu de réunion avec cette entreprise.",
      "no_meeting_description": "Contactez-les pour commencer à établir une relation avec eux."
    },
    "relationship_partners": {
      "title": "Associé(s) relationnel",
      "last_interaction_label": "Dernière interaction",
      "none_value": "Aucune",
      "no_partners_title": "Aucun associé(s) relationnel ajouté.",
      "no_partners_description": "Ajoutez des associé(s) relationnel qui sont responsables du maintien de cette relation."
    },
    "ignore": {
      "title": "Ignorer l'entreprise ?",
      "content": "Cette action supprimera définitivement l'entreprise de cette liste.",
      "label": "ignorer"
    },
    "bulk_ignore": {
      "title": "Ignorer les entreprises en lot",
      "content": "Cette action supprimera définitivement les entreprises de cette liste"
    },
    "company_type": {
      "update_title": "Mettre à jour le type d'entreprise",
      "update_link": "Mettre à jour le type d'entreprise",
      "label": "Type d'entreprise"
    },
    "order_by": {
      "label": "Trier par",
      "company_name_asc": "nom de l'entreprise croissant",
      "company_name_desc": "nom de l'entreprise décroissant",
      "created_at_asc": "créé le croissant",
      "created_at_desc": "créé le décroissant",
      "last_interaction_asc": "dernière interaction croissant",
      "last_interaction_desc": "dernière interaction décroissant",
      "interactions_90_days_asc": "interactions des 90 derniers jours croissant",
      "interactions_90_days_desc": "interactions des 90 derniers jours décroissant",
      "number_of_interactions_asc": "nombre d'interactions croissant",
      "number_of_interactions_desc": "nombre d'interactions décroissant",
      "archived_at_asc": "archivé le asc",
      "archived_at_desc": "archivé le desc"
    },
    "logo": {
      "update_title": "Mettre à jour le logo de l'entreprise",
      "update_caption": "Le logo ou l'image de l'entreprise sera recadré pour s'adapter au cadre. Le logo par défaut sera affiché si laissé vide.",
      "remove_title": "Êtes-vous sûr de vouloir supprimer le logo de l'entreprise ?",
      "remove_button": "Supprimer le logo",
      "upload_placeholder": "Glissez un fichier ici ou cliquez pour télécharger\n(taille maximale : 100 Ko. Utilisez un format PNG ou JPEG avec un ratio 1:1).",
      "upload_validation": "Veuillez télécharger une image",
      "alt_text": "Logo de {{companyName}}"
    },
    "contact_count": {
      "aria_label": "Il y a {{count}} contacts dans cette entreprise"
    },
    "relationship_partner": {
      "add_title": "Ajouter un associé(s) relationnel",
      "add_aria_label": "Mettre à jour le associé(s) relationnel",
      "label": "Associé(s) relationnel",
      "validation": {
        "required": "Veuillez ajouter un partenaire"
      }
    },
    "archive": {
      "confirm_title": "Veuillez confirmer l'archivage de cette entreprise",
      "confirm_content": "Êtes-vous sûr de vouloir archiver cette entreprise",
      "bulk_confirm_title": "Archivage en lot des entreprises",
      "bulk_confirm_content": "Veuillez confirmer l'archivage de ces entreprises",
      "bulk_label": "restauration en lot",
      "unarchive_confirm_title": "Désarchiver l'entreprise ?",
      "unarchive_confirm_content": "Veuillez confirmer le désarchivage de l'entreprise",
      "unarchive_aria_label": "désarchiver",
      "unarchive_title": "désarchiver",
      "bulk_unarchive_confirm_title": "Désarchivage en lot des entreprises ?",
      "bulk_unarchive_confirm_content": "Veuillez confirmer le désarchivage de ces entreprises",
      "bulk_unarchive_label": "désarchivage en lot"
    },
    "key_contacts": {
      "title": "Contacts clés",
      "no_contacts_title": "Aucun contact clé ajouté.",
      "no_contacts_description": "Ajoutez des contacts clés pour vous concentrer sur les relations qui comptent le plus.",
      "last_meeting": "Dernière réunion",
      "last_interaction": "Dernière interaction",
      "none": "Aucune",
      "add_title": "Ajouter un contact clé",
      "add_aria_label": "Ajouter un contact clé",
      "label": "Contact clé",
      "validation": {
        "required": "Veuillez sélectionner un contact clé"
      }
    },
    "office_locations": {
      "form": {
        "labels": {
          "labels": "Tags",
          "add_labels": "Ajouter des Tags"
        }
      },
      "remove": {
        "confirmation_title": "Supprimer l'adresse de l'entreprise",
        "confirmation_title_delete": "Êtes-vous sûr de vouloir supprimer cet emplacement ?",
        "confirmation_content": "Cela supprimera l'emplacement du bureau de tout contact lié à cette adresse.",
        "label": "supprimer l'emplacement"
      },
      "table": {
        "headers": {
          "address": "Adresse",
          "labels": "Tags"
        }
      },
      "labels": {
        "field_label": "Tags",
        "primary": "Principal",
        "headquarters": "Siège social",
        "placeholder": "Tags d'emplacement de bureau"
      },
      "tooltips": {
        "primary_info": "L'emplacement du bureau principal utilisé pour la communication et les dossiers.",
        "headquarters_info": "L'adresse officielle du siège social de l'entreprise."
      },
      "actions": {
        "add_location": "Ajouter un emplacement",
        "update_office_location": "mettre à jour l'emplacement du bureau"
      },
      "modals": {
        "company_locations": "Emplacements de l'entreprise",
        "company_address": "Adresse de l'entreprise",
        "add_location": "Ajouter un emplacement",
        "edit_address": "Modifier l'adresse",
        "update_company_address": "Mettre à jour l'adresse de l'entreprise"
      },
      "empty_state": {
        "no_locations_title": "Aucun emplacement de bureau ajouté pour le moment",
        "no_locations_description": "Commencez par ajouter une nouvelle adresse",
        "no_location_yet": "Cette entreprise n'a pas encore d'emplacement, ajoutez-en un maintenant"
      },
      "confirmations": {
        "update_warning": "En mettant à jour cette adresse d'entreprise, l'adresse de bureau du contact qui y est liée sera également mise à jour. Cette action ne peut pas être annulée.",
        "delete_restriction": "Vous ne pouvez pas supprimer l'emplacement du siège social ou du bureau principal."
      },
      "chips": {
        "more_label": "+{{count}} de plus"
      },
      "accessibility": {
        "office_location_actions": "actions d'emplacement de bureau",
        "primary_label_info": "informations sur l'étiquette principale",
        "headquarter_label_info": "informations sur l'étiquette du siège social"
      },
      "validation": {
        "please_choose_country": "Veuillez choisir un pays",
        "please_search_address": "Veuillez rechercher une adresse"
      }
    },
    "archived": {
      "table": {
        "headers": {
          "company": "Entreprise",
          "country": "Pays",
          "type": "Type",
          "interactions": "Interactions",
          "last_interaction": "Dernière interaction",
          "archived_at": "Archivé le"
        }
      },
      "actions": {
        "unblock_company": "débloquer l'entreprise",
        "block_company": "bloquer l'entreprise",
        "bulk_unarchive": "désarchivage en masse"
      },
      "order_by": "Trier par"
    },
    "engagement_overview": {
      "key_numbers": {
        "open_tasks_plural": "tâches ouvertes",
        "open_tasks_singular": "tâche ouverte",
        "upcoming_meetings_plural": "réunions à venir programmées",
        "upcoming_meetings_singular": "réunion à venir programmée",
        "open_opportunities_plural": "opportunités ouvertes",
        "open_opportunities_singular": "opportunité ouverte",
        "tooltip_pattern": "Vous avez {{count}} {{label}}",
        "visit_label": "visiter {{label}}"
      }
    },
    "documents": {
      "actions": {
        "add_document": "ajouter un document",
        "edit_document": "modifier le document de l'entreprise",
        "remove_document": "supprimer le document de l'entreprise",
        "document_button": "Document"
      },
      "removal": {
        "confirm_title": "Êtes-vous sûr de vouloir supprimer ce document ?"
      }
    },
    "who_knows": {
      "no_contacts_title": "Aucun contact",
      "no_contacts_description": "Personne de votre entreprise n'a contacté cette organisation."
    },
    "report_incorrect_info": {
      "report_incorrect_info": "Signaler des informations incorrectes",
      "modal_header": "Signaler des informations incorrectes sur l'entreprise",
      "incorrect_fields": "Champs incorrects",
      "comments": "Commentaires",
      "report": "Signaler",
      "fields": {
        "name": "Nom",
        "logo": "Logo",
        "location": "Localisation",
        "phone_numbers": "Numéros de téléphone",
        "domain": "Domaine",
        "industry": "Industrie"
      }
    }
  },
  "key_activity": {
    "slide": {
      "aria_label": "diapositive d'activité clé",
      "details": "Détails",
      "list_fields": "Champs de liste",
      "contacts_involved": "Contacts Impliqués",
      "staff_involved": "Personnel Impliqué",
      "note": "Note",
      "comments": "Commentaires"
    },
    "performance": {
      "current": "Actuel",
      "best": "Meilleur",
      "consecutive": "Consécutif",
      "longest": "Plus Long",
      "weeks": "Semaines",
      "current_tooltip": "Vous avez enregistré {{count}} activités clés ce mois-ci",
      "best_tooltip": "Votre record personnel : {{count}} activités clés en un mois",
      "consecutive_tooltip": "Vous avez enregistré des activités clés hebdomadaires pendant {{count}} semaines",
      "longest_tooltip": "Votre plus longue série : {{count}} semaines"
    },
    "firm_wide": {
      "title": "Entreprise Entière",
      "this_month": "Ce Mois-ci",
      "tooltip": "Total des activités clés dans l'entreprise ce mois-ci"
    },
    "grid": {
      "loading_aria_label": "chargement des activités clés",
      "load_limit_message": "Il y a plus d'activités clés que celles affichées.",
      "show_less": "afficher moins",
      "show_more": "+{{count}} de plus",
      "headers": {
        "date": "Date",
        "activity": "Activité",
        "contact_involved": "Contact Impliqué",
        "type": "Type",
        "description": "Description",
        "note": "Note",
        "staff_involved": "Personnel Impliqué"
      }
    },
    "filters": {
      "select_employee": "Sélectionner un Employé",
      "select_month_year": "sélectionner le mois et l'année",
      "select_activity_category": "sélectionner la catégorie d'activité",
      "all_employees": "Tous",
      "basic": "Basique",
      "large": "Grande",
      "select_all": "Tout sélectionner",
      "categories": {
        "transactional": "Transactionnel",
        "key_activity": "Activité clé"
      },
      "items": {
        "emails": "Courriels",
        "meetings": "Réunions",
        "lead_activities": "Activités de prospect",
        "bd_activities": "Activités BD",
        "marketing_activities": "Activités marketing"
      }
    },
    "chart": {
      "business_development": "Activité de Développement des affaires",
      "lead_activity": "Activité de Prospect",
      "marketing_activity": "Activité Marketing"
    },
    "categories": {
      "business_development": "Développement des affaires",
      "lead": "Prospect",
      "marketing": "Marketing"
    },
    "forms": {
      "log_new_activity": "Enregistrer une nouvelle activité",
      "edit_key_activity": "Modifier l'activité clé",
      "delete_key_activity": "Supprimer l'activité clé",
      "date_time_label": "Date et heure de l'activité",
      "end_date_time_label": "Date et heure de fin",
      "type_label": "Type",
      "activity_label": "Activité",
      "contacts_involved_label": "Contacts impliqués",
      "staff_involved_label": "Personnel impliqué",
      "notes_label": "Notes",
      "contacts_selected": "{{count}} contacts sélectionnés",
      "labels": {
        "activity": "Activité",
        "description": "Description",
        "type": "Type",
        "notes": "Notes"
      },
      "placeholders": {
        "activity": "Activité",
        "notes": "Notes",
        "activity_title": "Titre de l'activité"
      },
      "validation": {
        "choose_activity": "Veuillez choisir une activité",
        "choose_activity_type": "Veuillez choisir un type d'activité",
        "record_date_time": "Veuillez enregistrer la date et l'heure",
        "choose_contact": "Veuillez choisir au moins un contact",
        "end_date_after_start": "La date de fin doit être postérieure à la date de début"
      }
    },
    "modals": {
      "activity_details": "Détails de l'activité",
      "delete_activity": "Supprimer l'activité",
      "edit_activity": "Modifier l'activité"
    },
    "interactions": {
      "had_meeting_with": " a eu une réunion avec ",
      "sent_email_to": " a envoyé un courriel à ",
      "with": " avec ",
      "private_between_participants": "{{type}} privé entre {{count}} participants",
      "from": "De : ",
      "to": "À : "
    },
    "notes": {
      "view_notes": "Voir les notes",
      "hide_notes": "Masquer les notes"
    },
    "navigation": {
      "show_less": "afficher moins",
      "show_all": "tout afficher",
      "others": "autres"
    },
    "actions": {
      "update_aria_label": "mettre à jour l'activité clé",
      "update_title": "mettre à jour l'activité clé",
      "remove_aria_label": "supprimer l'activité clé",
      "remove_title": "supprimer l'activité clé",
      "log_new_activity": "Enregistrer une nouvelle activité",
      "remove_activity": "Supprimer l'activité",
      "edit_activity": "Modifier l'activité",
      "add_to_list": "Ajouter à la liste",
      "delete_activity": "Supprimer l'activité",
      "mark_as_bd_activity": "Marquer comme activité BD",
      "actions_aria_label": "Actions {{title}}",
      "edit": "Modifier",
      "delete": "Supprimer",
      "save": "Enregistrer"
    },
    "category_titles": {
      "business_development": "activité de développement des affaires",
      "lead": "activité de prospect",
      "marketing": "activité marketing",
      "unknown": "activité inconnue"
    },
    "category_labels": {
      "business_development": "activité de développement des affaires",
      "lead": "activité de prospect",
      "marketing": "activité marketing",
      "unknown": "activité inconnue"
    },
    "email_directions": {
      "employee_sent": "Courriel envoyé",
      "employee_received": "Courriel reçu"
    },
    "activity_title": {
      "meeting": "Réunion",
      "email": "Courriel"
    },
    "removal": {
      "confirmation_title": "Êtes-vous sûr ?",
      "confirmation_content": "La suppression de l'activité supprimera définitivement l'activité et la retirera du flux d'activité des contacts, du calendrier et de toutes les listes auxquelles l'activité a été ajoutée."
    },
    "timeline": {
      "upcoming_activities": "Activités à venir",
      "past_activities": "Activités passées"
    },
    "months": {
      "january": "Janvier",
      "february": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Août",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre"
    },
    "participants": {
      "private_interaction": "{{type}} privé entre {{count}} participants"
    },
    "types": {
      "email": "Courriel",
      "meeting": "Réunion",
      "email_sent": "Courriel envoyé",
      "email_received": "Courriel reçu",
      "had_meeting_with": " a eu une réunion avec ",
      "sent_email_to": " a envoyé un courriel à ",
      "with": " avec "
    },
    "header": {
      "log_activity": "Enregistrer une activité",
      "search_placeholder": "Rechercher par titre d'activité",
      "date_label": "Date",
      "filter_label": "Filtrer",
      "filters_active_aria": "{{count}} filtres sont actifs"
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Merci pour la mise à jour :)"
    },
    "contact_request_page": {
      "thank_you_message": "Merci d'avoir ajouté vos contacts. Vous pouvez maintenant fermer cette fenêtre.",
      "im_done": "J'ai terminé"
    },
    "header": {
      "instruction_text": "Veuillez sélectionner et ajouter vos contacts que vous souhaitez ajouter à la liste \"{{listName}}\". Une fois que vous avez ajouté vos contacts, cliquez sur \"J'ai terminé\"."
    },
    "my_contacts": {
      "my_contacts": "Mes Contacts",
      "company_type": "Type de entreprise",
      "consent_status": "Statut de consentement",
      "no_contacts_message": "Il n'y a aucun contact à afficher ici"
    },
    "bulk_add": {
      "contact_list": "Liste de Contacts",
      "bulk_add_description": "Ajouter des contacts en lot à la liste",
      "adding_in_progress_message": "Le contact est en cours d'ajout. Veuillez actualiser la page pour voir la liste mise à jour.",
      "adding_in_progress_title": "Ajout de Contact en Cours",
      "add_selected": "Ajouter la Sélection"
    },
    "contacts_table": {
      "selected": "sélectionnés",
      "contact": "Contact",
      "company": "Entreprise",
      "location": "Lieu",
      "last_interaction": "Dernière Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "diapositive de réunion",
      "add_key_activity": "Ajouter une activité clé",
      "contacts_involved": "Contacts impliqués",
      "staff_involved": "Personnel impliqué",
      "companies": "Entreprises"
    },
    "upcoming": {
      "cancelled": "[Annulé]",
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement des affaires",
      "no_meetings_coming_up": "Aucune réunion à venir"
    },
    "recent": {
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement des affaires",
      "create_task": "Créer une tâche",
      "create_note": "Créer une note",
      "no_recent_meetings": "Vous n'avez pas eu de réunion depuis un moment"
    },
    "calendar_view": {
      "all": "Tout",
      "select_all": "Tout sélectionner",
      "tasks": "Tâches",
      "external_meetings": "Réunions externes",
      "key_activities": "Activités clés",
      "task_tooltip": "tâche"
    },
    "contact_table": {
      "show_less": "Afficher moins",
      "show_more": "Afficher plus"
    },
    "key_activity": {
      "view_activity_details": "voir les détails de l'activité",
      "activity": "Activité",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Modifier l'activité",
      "remove": "Supprimer"
    }
  },
  "company_list": {
    "show_personal_info": "Afficher les informations personnelles",
    "close_personal_info": "Fermer les informations personnelles"
  },
  "reports": {
    "search_placeholder": "Rechercher un rapport",
    "loading": "Chargement des rapports",
    "loading_report": "Chargement du rapport",
    "empty_state": "Aucun rapport disponible",
    "browser_not_supported": "Votre navigateur ne prend pas en charge les iframes."
  },
  "employee": {
    "autocomplete": {
      "no_options_text": "commencez à taper pour rechercher des employés",
      "all_option": "Tous"
    },
    "engagement": {
      "relationship_partner": {
        "title": "Associé(s) relationnel",
        "description": "Toutes les entreprises où cet employé est un associé(s) relationnel"
      },
      "top_companies": {
        "title": "Top 10 des Entreprises",
        "description": "Top 10 des entreprises par nombre d'interactions"
      },
      "top_contacts": {
        "title": "Top 10 des Contacts",
        "description": "Top 10 des contacts par nombre d'interactions"
      },
      "table_headers": {
        "company": "Entreprise",
        "opportunities": "Opportunités",
        "partners": "Partenaires",
        "type": "Type",
        "engagement": "Engagement",
        "industry": "Industrie",
        "internal_industry": "Industrie Interne",
        "contact": "Contact",
        "interactions_count": "# d'Interactions",
        "who_knows": "Qui Connaît"
      }
    }
  },
  "hierarchy": {
    "slide": {
      "title": "Hiérarchie d'entreprise",
      "loading_aria_label": "chargement de la hiérarchie d'entreprise",
      "errors": {
        "cannot_move": "Impossible de déplacer l'entreprise :",
        "problem_showing": "Problème d'affichage de la hiérarchie :"
      }
    },
    "view": {
      "dense_view": "Vue dense",
      "view_hierarchy": "Voir la hiérarchie d'entreprise",
      "companies_count": "Entreprises :",
      "syncing_hierarchy": "Synchronisation de la hiérarchie d'entreprise",
      "sync_success": "Entreprise ajoutée avec succès à la hiérarchie"
    },
    "info": {
      "last_interaction": "Dernière interaction"
    },
    "actions": {
      "add_child_company": "ajouter une nouvelle entreprise enfant sous",
      "update_fields": "Mettre à jour les champs",
      "update_field": "mettre à jour le champ",
      "hide_children": "Masquer les entreprises enfants de",
      "show_children": "Afficher les entreprises enfants de"
    },
    "removal": {
      "confirmation_title": "Êtes-vous sûr ?",
      "confirmation_content": "Cliquez sur confirmer pour retirer l'entreprise de la hiérarchie. Vous pouvez toujours la rajouter plus tard",
      "remove_label": "Retirer {{companyName}} de la hiérarchie"
    },
    "placement": {
      "title": "Placement",
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "location": "Localisation",
          "actions": "Actions"
        },
        "changed_company": "Entreprise changée",
        "ignore_contact": "ignorer le contact",
        "add_to_hierarchy": "ajouter à la hiérarchie"
      },
      "ignore": {
        "confirmation_title": "Ignorer le contact ?",
        "confirmation_content": "Cette action supprimera définitivement le contact de cette liste.",
        "label": "ignorer"
      }
    },
    "contacts": {
      "move_in_hierarchy": "Déplacer les contacts dans la hiérarchie",
      "move_contacts": "Déplacer les contacts",
      "select_company": "Sélectionner une entreprise",
      "company_placeholder": "Entreprise",
      "create_new_company": "Créer une nouvelle entreprise ici"
    },
    "company_creation": {
      "modal_title": "Créer une nouvelle entreprise",
      "create_link": "créer une nouvelle entreprise ici",
      "submit_button": "Ajouter",
      "domain_label": "Quel domaine courriel les contacts de cette entreprise utilisent-ils ?",
      "domain_placeholder": "Domaine courriel",
      "domain_caption": "Tapez le domaine courriel que les contacts de cette entreprise utiliseront. Laissez vide s'il utilise le même que l'entreprise actuelle.",
      "name_label": "Quel est le nom de l'entreprise ?",
      "name_placeholder": "Nom de l'entreprise",
      "name_caption": "Vous pouvez changer le nom de l'entreprise à tout moment.",
      "company_domain_label": "Domaine de l'entreprise",
      "company_name_label": "Nom de l'entreprise"
    },
    "bulk_associate": {
      "add_to_hierarchy": "Ajouter une entreprise à la hiérarchie",
      "modal_title": "Ajouter une entreprise à la hiérarchie",
      "select_companies": "Sélectionner les entreprises",
      "companies_placeholder": "Entreprises",
      "if_not_exist": "Si l'entreprise n'existe pas encore,"
    },
    "validation": {
      "company_required": "L'entreprise est requise",
      "company_name_required": "Le nom de l'entreprise est requis",
      "select_one_company": "veuillez sélectionner au moins une entreprise",
      "enter_company_name": "veuillez entrer un nom d'entreprise"
    }
  },
  "updated_contacts": {
    "no_updates": {
      "title": "Nexl maintient automatiquement vos contacts à jour.",
      "description": "Dès que Nexl découvre qu'un de vos contacts a mis à jour son profil LinkedIn, nous vous en informerons ici et maintiendrons vos contacts à jour. Cela ne fonctionne que pour les contacts avec une URL LinkedIn valide."
    },
    "table": {
      "headers": {
        "previous": "Précédent",
        "current": "Actuel",
        "date": "Date"
      }
    },
    "company_type": "Type d'entreprise"
  },
  "company_details": {
    "title": "Détails de l'entreprise",
    "client_id": "ID Client",
    "group_id": "ID Groupe",
    "internal_industries": "Industries internes",
    "industries": "Industries",
    "description": "Description",
    "primary_location": "Emplacement principal",
    "phone": "Téléphone",
    "emails": "Courriels",
    "domains": "Domaine(s)",
    "website": "Site web",
    "employees": "Employés",
    "linkedin": "LinkedIn",
    "twitter": "Twitter"
  },
  "company_actions": {
    "add_location": "Ajouter un emplacement",
    "set_location": "Définir l'emplacement",
    "view_all": "Voir tout",
    "create_note": "Créer une note",
    "create_opportunity": "Créer une opportunité",
    "log_new_activity": "Enregistrer une nouvelle activité",
    "add_to_list": "Ajouter à la liste",
    "add_company": "Ajouter l'entreprise \"{{companyName}}\"",
    "update_company_logo": "Mettre à jour le logo de l'entreprise",
    "edit_company_details": "Modifier les détails de l'entreprise",
    "edit_address_details": "Modifier les détails de l'adresse",
    "report_incorrect_info": "Signaler des informations incorrectes",
    "audit_trail": "Piste d'audit",
    "referred_by": "Référé par",
    "archive_company": "Archiver l'entreprise"
  },
  "company_autocomplete": {
    "start_typing": "Commencez à taper pour rechercher des entreprises",
    "no_company_found": "Aucune entreprise trouvée pour \"{{term}}\""
  },
  "notes": {
    "empty_state": "Il n'y a pas encore de note sur ce contact"
  },
  "cleaner": {
    "company": {
      "incomplete": {
        "title": "Incomplètes",
        "description": "Ces entreprises ont des données incomplètes telles que l'emplacement, l'industrie et le type."
      },
      "duplicate": {
        "title": "Doublons",
        "description": "Ces entreprises ont des noms de domaine similaires. Vous pouvez fusionner les entreprises ou les garder séparées.",
        "warning": "La fusion d'entreprises ne peut pas être annulée.",
        "merge_details": "Lors de la fusion, nous combinerons les contacts et interactions des deux entreprises. Toutes les notes, tâches et documents autres que ceux de l'entreprise principale seront définitivement supprimés."
      },
      "archived": {
        "title": "Archivées",
        "description": "Ces contacts ou entreprises ont été supprimés de la base de données active"
      }
    },
    "contact": {
      "incomplete": {
        "title": "Contacts incomplets",
        "description": "Ces contacts ont des données incomplètes telles que le nom, le rôle et l'emplacement."
      },
      "duplicate": {
        "title": "Doublons",
        "description": "Ces contacts ont les mêmes informations telles que le nom. Pour combiner le contact, veuillez indiquer si ces contacts sont identiques ou uniques."
      },
      "unengaged": {
        "title": "Non engagés",
        "description": "Ces contacts n'ont pas interagi avec votre entreprise depuis un certain temps. Réactivez les contacts non engagés avec un courriel ou une réunion."
      },
      "bounced": {
        "title": "Rejetés",
        "description": "Les courriels de ces contacts ont récemment été rejetés. Veuillez modifier le courriel vers la bonne adresse ou archiver le contact pour qu'il soit supprimé des listes."
      }
    },
    "tabs": {
      "company": "Entreprise",
      "contact": "Contact"
    }
  },
  "company": {
    "activity_history": {
      "view_all_bd_activities": "Voir toutes les activités BD",
      "bd_lead_marketing_activities": "Activités BD & Prospects & Marketing"
    },
    "meeting_history": {
      "view_meeting_history": "Voir l'historique des réunions",
      "meeting_history_title": "Historique des réunions"
    },
    "prospects": {
      "title": "Développer les relations clients / Prospect",
      "search": {
        "name": "Nom",
        "job_title": "Titre du poste",
        "location": "Localisation",
        "search": "Rechercher"
      },
      "table": {
        "prospect": "Prospect",
        "location": "Localisation",
        "email": "Courriel",
        "action": "Action"
      },
      "banner": "Nous faisons de notre mieux pour maintenir les résultats aussi à jour que possible, mais vous pourriez trouver des contacts qui ont déjà rejoint une nouvelle entreprise. Veuillez vérifier le profil LinkedIn du contact pour obtenir les informations les plus récentes. Toutes les adresses courriel fournies ne peuvent pas être vérifiées. Par conséquent, nous ne pouvons pas garantir l'exactitude des coordonnées fournies. N'utilisez pas les prospects dans vos campagnes de courriels automatisées.",
      "status": {
        "searching": "Recherche en cours",
        "still_searching": "Recherche toujours en cours",
        "view_contact": "Voir le contact",
        "no_contact_details": "Nous n'avons pas encore trouvé de coordonnées. Veuillez vérifier à nouveau dans 30 minutes."
      }
    },
    "insights": {
      "stats": {
        "activity_past_90_days": "Activité des 90 derniers jours",
        "updated": "Mis à jour",
        "interactions": "Interactions",
        "emails": "Courriels",
        "meetings": "Réunions"
      },
      "engagement": {
        "over_time": "Engagement dans le temps",
        "by_practice_group": "Engagement par groupe de pratique"
      },
      "opportunities": {
        "opportunity": "Opportunité",
        "referrals": "Références",
        "success_rate": "Taux de réussite",
        "total_open": "Total des opportunités ouvertes",
        "total_won": "Total des opportunités gagnées",
        "total_open_referred": "Total des opportunités référées ouvertes",
        "total_referred_won": "Total des opportunités référées gagnées",
        "amount_in": "Montant en"
      },
      "departments": {
        "practice_group": "Groupe de pratique",
        "interactions": "Interactions"
      }
    },
    "reporting": {
      "iframe_title": "rapports d'entreprise (PowerBI)"
    },
    "tabs": {
      "directory": "RÉPERTOIRE",
      "notes": "Notes",
      "create_task": "Créer une tâche",
      "loading_notes": "Chargement des notes...",
      "aria_labels": {
        "active_opportunities": "opportunités actives",
        "open_tasks": "tâches ouvertes"
      },
      "additional": {
        "name_taken": "Le nom est déjà pris"
      }
    }
  },
  "contact_management": {
    "update": {
      "email": {
        "title": "Mettre à jour le courriel",
        "modal_header": "Mettre à jour le courriel du contact"
      }
    },
    "bounced": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "last_interaction": "Dernière interaction",
          "created_at": "Créé le",
          "actions": "Actions"
        }
      },
      "actions": {
        "remove_status": "supprimer le statut rebond",
        "unbounce": {
          "confirmation_title": "Supprimer le statut rebond",
          "confirmation_content": "Marquer le courriel comme non rebondi ?"
        }
      }
    },
    "privacy": {
      "set_public": {
        "title": "Définir le contact comme public",
        "content": "Toutes les futures interactions entre vous et ce contact seront suivies. Les interactions passées lorsque le contact était défini comme privé n'apparaîtront pas."
      },
      "set_private": {
        "title": "Définir le contact comme privé",
        "content": "Toutes les futures interactions (par ex. flux d'activité, qui connaît) qui vous incluent vous et ce contact ne seront pas suivies.",
        "delete_past_interactions": "Supprimer les interactions passées entre vous et ce contact."
      },
      "action_text": "Définir le contact comme {{status}}",
      "status": {
        "public": "public",
        "private": "privé"
      }
    },
    "ignore": {
      "single": {
        "confirmation_title": "Ignorer le contact ?",
        "confirmation_content": "Cette action supprimera définitivement le contact de cette liste."
      },
      "bulk": {
        "confirmation_title": "Ignorer les contacts en masse ?",
        "confirmation_content": "Cette action supprimera définitivement les contacts de cette liste."
      }
    },
    "hierarchy": {
      "move": {
        "button_text": "Déplacer le contact",
        "modal_title": "Déplacer le contact dans la hiérarchie",
        "company_label": "Entreprise",
        "company_placeholder": "Vers quelle entreprise voulez-vous déplacer le contact",
        "validation": {
          "company_required": "Veuillez sélectionner une entreprise"
        }
      }
    },
    "marketing": {
      "allowance": {
        "description": "Nombre de contacts uniques que nous avons envoyés depuis les campagnes par mois",
        "table": {
          "headers": {
            "month": "Mois",
            "contacts_count": "Nombre de contacts",
            "allowance": "Allocation",
            "utilisation": "Utilisation"
          }
        }
      }
    }
  },
  "move_to_company": {
    "button": "Déplacer vers l'entreprise",
    "company_label": "Entreprise",
    "move_contact_button": "Déplacer le contact"
  },
  "unengaged": {
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "last_interaction": "Dernière interaction",
        "action": "Action"
      }
    },
    "actions": {
      "archive_contact": "archiver le contact",
      "add_to_list": "Ajouter à la liste"
    },
    "order_by": {
      "label": "Trier par"
    }
  },
  "email_management": {
    "modals": {
      "add_personal_email": "Ajouter un courriel personnel",
      "add_company_email": "Ajouter un courriel d'entreprise",
      "add_new_contact": "Ajouter un nouveau contact à la personne"
    },
    "fields": {
      "new_work_email": "Nouvel courriel professionnel",
      "email_address": "Adresse courriel",
      "enter_email_placeholder": "Saisir l'adresse courriel"
    },
    "actions": {
      "add_email": "Ajouter l'courriel"
    },
    "validation": {
      "enter_valid_email": "Veuillez saisir un courriel valide pour créer le contact",
      "start_typing_search": "commencez à taper pour rechercher un contact",
      "create_contact": "Créer le contact \"{{email}}\"",
      "error_validating_email": "Une erreur s'est produite lors de la validation de l'courriel.",
      "use_valid_email": "Veuillez utiliser une adresse courriel valide."
    },
    "duplicates": {
      "review_duplicates": "Examiner les doublons potentiels",
      "potential_duplicate_detected": "Doublon potentiel de personne détecté"
    }
  },
  "classified": {
    "private_contact": "Contact privé"
  },
  "export": {
    "export_contacts": "Exporter les contacts"
  },
  "person_profile": {
    "actions": {
      "archive_person": "Archiver la personne",
      "edit_details": "Modifier les détails",
      "update_contact": "Mettre à jour le contact"
    },
    "tabs": {
      "details": "Détails",
      "experience": "Expérience",
      "education": "Éducation",
      "skills_and_interest": "Compétences et intérêts"
    },
    "details": {
      "first_name_last_name": "Prénom / Nom",
      "personal_address": "Adresse personnelle",
      "phone_numbers": "Numéros de téléphone",
      "links": "Liens"
    },
    "forms": {
      "first_name": "Prénom",
      "last_name": "Nom",
      "phone_number": "Numéro de téléphone",
      "physical_address": "Adresse physique",
      "social_media": "Réseaux sociaux",
      "linkedin": "LinkedIn",
      "twitter": "Twitter",
      "linkedin_url": "URL LinkedIn",
      "twitter_url": "URL Twitter",
      "personal_information": "Informations personnelles",
      "changes_saved": "Modifications enregistrées !",
      "error_submitting": "Une erreur s'est produite lors de la soumission du formulaire.",
      "search_address": "Rechercher une adresse"
    },
    "contacts": {
      "title": "Contacts",
      "description": "Une personne peut avoir plusieurs contacts, chacun montrant une association ou affiliation différente—comme avec une entreprise ou un courriel personnel",
      "link": "Lier"
    },
    "experience": {
      "loading": "Chargement de l'expérience..."
    },
    "empty_state": {
      "nothing_to_show": "Rien à afficher pour le moment",
      "click_edit_details": "Cliquez sur Modifier les détails pour ajouter des informations sur la personne"
    }
  },
  "career_companies": {
    "modal": {
      "create_title": "Créer une nouvelle expérience",
      "edit_title": "Modifier l'expérience"
    },
    "actions": {
      "add_experience": "Ajouter une expérience"
    },
    "form": {
      "labels": {
        "company": "Entreprise",
        "company_name": "Nom de l'entreprise",
        "job_title": "Titre du poste",
        "start_date": "Date de début",
        "end_date": "Date de fin"
      },
      "placeholders": {
        "search_company": "Tapez pour rechercher une entreprise"
      },
      "validation": {
        "job_title_required": "Veuillez saisir un titre de poste",
        "start_date_required": "Veuillez saisir une date de début",
        "end_date_required": "Veuillez saisir une date de fin"
      }
    },
    "sections": {
      "companies_title": "Entreprises"
    }
  },
  "states": {
    "messages": {
      "no_data_source": "Aucune source de données fournie.",
      "no_table_definition": "Aucune définition de table fournie."
    }
  },
  "filters": {
    "date": {
      "equals": "Égal à",
      "not_equal": "Différent de",
      "before": "Avant",
      "after": "Après",
      "between": "Entre"
    }
  },
  "grid": {
    "contact": "Contact",
    "actions": "Actions",
    "email": "Courriel",
    "last_logged_in": "Dernière connexion",
    "role": "Rôle"
  }
}
